import { AsyncStateAlert } from '@ui/general';
import { createAsyncSelectors } from '@lib/selectors';
import { Email } from '@ui/form-items';
import { GatewayCard } from '../general';
import { securityActions } from '@sonar-software/sonar-security';
import { SonarText } from '@ui/text';
import { useNavigate } from 'react-router-dom';
import { Button, Form, Row } from 'antd';
import { COPY_SPECIFIC, FORGOT_PASSWORD_COPY, FULL_ROUTES, NOTIFICATIONS_COPY } from '@sonar-software/sonar-ts-constants';
import React, { useCallback } from 'react';
import { useAction, useSonarSelector } from '@hooks';
const forgotPasswordSelectors = createAsyncSelectors((state) => state.security.authentication.forgotPassword.post);
export const ForgotPasswordView = () => {
    const navigate = useNavigate();
    const requestForgotPassword = useAction(securityActions.requestPostSecurityAuthenticationForgotPassword);
    const resetForgotPassword = useAction(securityActions.resetPostSecurityAuthenticationForgotPassword);
    const hasError = useSonarSelector(forgotPasswordSelectors.isErrored);
    const hasFailed = useSonarSelector(forgotPasswordSelectors.isFailed);
    const hasOpenRequest = useSonarSelector(forgotPasswordSelectors.isRequested);
    const hasSuccess = useSonarSelector(forgotPasswordSelectors.isReceived);
    const handleOnBackToLoginClick = useCallback(() => {
        navigate(FULL_ROUTES.LOGIN);
    }, [navigate]);
    const handleOnFinish = useCallback((values) => {
        var _a;
        requestForgotPassword({ email: (_a = values.email) === null || _a === void 0 ? void 0 : _a.trim() });
    }, [requestForgotPassword]);
    const handleOnValuesChange = () => {
        if (hasError || hasFailed || hasSuccess) {
            resetForgotPassword();
        }
    };
    return (React.createElement(GatewayCard, { id: 'forgot-password', title: FORGOT_PASSWORD_COPY.FORGOT_PASSWORD_HEADER },
        React.createElement(Form, { onFinish: handleOnFinish, onValuesChange: handleOnValuesChange },
            React.createElement(SonarText, { className: 'sub-text' }, FORGOT_PASSWORD_COPY.FORGOT_PASSWORD_SUBTEXT),
            React.createElement(AsyncStateAlert, { errored: NOTIFICATIONS_COPY.ERROR_FORGOT_PASSWORD, failed: NOTIFICATIONS_COPY.FAILED_FORGOT_PASSWORD, received: NOTIFICATIONS_COPY.SUCCESS_FORGOT_PASSWORD, stateSelector: forgotPasswordSelectors.state }),
            React.createElement(Email, { disabled: hasOpenRequest, id: 'forgot-password-email', size: 'large' }),
            React.createElement(Row, { justify: 'space-between' },
                React.createElement(Button, { disabled: hasOpenRequest, id: 'forgot-password-return-button', onClick: handleOnBackToLoginClick, size: 'large' }, COPY_SPECIFIC.BACK_TO_LOGIN),
                React.createElement(Button, { htmlType: 'submit', id: 'forgot-password-submit-button', loading: hasOpenRequest, size: 'large', type: 'primary' }, COPY_SPECIFIC.SEND_INSTRUCTIONS)))));
};
